var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "terms__content" }, [
    _c("h3", [_vm._v(_vm._s(_vm.$t("policy.list[0].title")))]),
    _vm._v(" "),
    _c("ol", [
      _c("li", [_vm._v(_vm._s(_vm.$t("policy.list[0].clarification[0]")))]),
      _vm._v(" "),
      _c("li", [_vm._v(_vm._s(_vm.$t("policy.list[0].clarification[1]")))]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [
          _vm._v(_vm._s(_vm.$t("policy.list[0].clarification[2]")))
        ])
      ]),
      _vm._v(" "),
      _c("li", [_vm._v(_vm._s(_vm.$t("policy.list[0].clarification[3]")))]),
      _vm._v(" "),
      _c("li", [_vm._v(_vm._s(_vm.$t("policy.list[0].clarification[4]")))]),
      _vm._v(" "),
      _c("li", [_vm._v(_vm._s(_vm.$t("policy.list[0].clarification[5]")))]),
      _vm._v(" "),
      _c("li", [_vm._v(_vm._s(_vm.$t("policy.list[0].clarification[6]")))]),
      _vm._v(" "),
      _c("li", [_vm._v(_vm._s(_vm.$t("policy.list[0].clarification[6]")))])
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(_vm._s(_vm.$t("policy.list[0].text[0]")) + "\n    "),
      _c("a", { attrs: { href: "mailto:" + _vm.supportEmail } }, [
        _vm._v(_vm._s(_vm.supportEmail))
      ]),
      _vm._v(".")
    ]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.$t("policy.list[1].title")))]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.$t("policy.list[1].subtitle")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("policy.list[1].text[0]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("policy.list[1].text[1]")))]),
    _vm._v(" "),
    _c("ul", [
      _c("li", [_vm._v(_vm._s(_vm.$t("policy.list[1].clarification[0]")))]),
      _vm._v(" "),
      _c("li", [_vm._v(_vm._s(_vm.$t("policy.list[1].clarification[1]")))]),
      _vm._v(" "),
      _c("li", [_vm._v(_vm._s(_vm.$t("policy.list[1].clarification[2]")))])
    ]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("policy.list[1].text[2]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("policy.list[1].text[3]")))]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.$t("policy.list[2].title")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("policy.list[2].text[0]")))]),
    _vm._v(" "),
    _c("h3", [_vm._v(_vm._s(_vm.$t("policy.list[2].subtitle")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("policy.list[2].text[1]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("policy.list[2].text[2]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("policy.list[2].text[3]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("policy.list[2].text[4]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("policy.list[2].text[5]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("policy.list[2].text[6]")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("policy.list[2].text[7]")))]),
    _vm._v(" "),
    _c("p", [
      _vm._v("\n    " + _vm._s(_vm.$t("policy.list[2].text[8]")) + "\n    "),
      _c("a", { attrs: { href: "mailto:" + _vm.supportEmail } }, [
        _vm._v(_vm._s(_vm.supportEmail))
      ]),
      _vm._v("\n    " + _vm._s(_vm.$t("policy.list[2].text[9]")) + "\n  ")
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v("\n    " + _vm._s(_vm.$t("policy.list[2].text[10]"))),
      _c("br"),
      _vm._v("\n    " + _vm._s(_vm.$t("policy.list[2].text[11]")) + "\n    "),
      _c("a", { attrs: { href: "mailto:" + _vm.supportEmail } }, [
        _vm._v(_vm._s(_vm.supportEmail))
      ]),
      _c("br"),
      _vm._v("\n    " + _vm._s(_vm.$t("policy.list[2].text[12]"))),
      _c("br"),
      _vm._v("\n    " + _vm._s(_vm.$t("policy.list[2].text[13]"))),
      _c("br"),
      _vm._v("\n    " + _vm._s(_vm.$t("policy.list[2].text[14]"))),
      _c("br"),
      _vm._v("\n    " + _vm._s(_vm.$t("policy.list[2].text[15]"))),
      _c("br"),
      _vm._v("\n    " + _vm._s(_vm.$t("policy.list[2].text[16]"))),
      _c("br"),
      _vm._v("\n    " + _vm._s(_vm.$t("policy.list[2].text[17]")) + "\n  ")
    ]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("policy.list[2].text[18]")))])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }